export default __webpack_public_path__ + "static/media/ic_attachment_black.ede06e36.svg";